import Layout from '@/views/main/Main.vue'
import type { RouteRecordRaw } from "vue-router";
const platformRouter: RouteRecordRaw = {
    path: '/platform',
    component: Layout,
    redirect: 'noredirect',
    meta: {
        icon: 'el-icon-s-goods',
        title: '平台管理'
    },
    children: [
        {
            path: '/platform/menu',
            component: () => import("@/views/main/platform/menu/menu.vue"),
            name: 'menu',
            meta: {
                title: '菜单管理'
            }
        },
        {
            path: '/platform/pdamenu',
            component: () => import("@/views/main/platform/pdaMenu/index.vue"),
            name: 'pdaMenu',
            meta: {
                title: 'pda菜单管理'
            }
        },
        {
            path: '/platform/exLog',
            component: () => import("@/views/main/platform/exLog/exLog.vue"),
            name: 'exLog',
            meta: {
                title: '异常日志'
            }
        },
        {
            path: '/platform/actLog',
            component: () => import("@/views/main/platform/actLog/actLog.vue"),
            name: 'log',
            meta: {
                title: '操作日志'
            }
        },
        {
            path: '/platform/visLog',
            component: () => import("@/views/main/platform/visLog/visLog.vue"),
            name: 'visLog',
            meta: {
                title: '访问日志'
            }
        },
        {
            path: '/platform/timers',
            component: () => import('@/views/main/platform/timers/timers.vue'),
            name: 'timers',
            meta: {
                title: '任务调度'
            }
        }
    ]
}
export default platformRouter